import {CommonModule} from '@angular/common';
import { HttpClient } from '@angular/common/http';
import {NgModule} from '@angular/core';
import {SinceYearModule} from '@im-ng/ui/since-year';
import {TranslateModule} from '@ngx-translate/core';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import {DlsComponent} from '../apps/dls.component';
import {ImrPipe} from '../apps/imr.pipe';
import {MainHeadComponent} from '../apps/main-head.component';
import {ScreenshotsComponent} from '../apps/screenshots.component';
import {TechnologyAdvantagesComponent} from '../apps/technology-advantages.component';
import {UlComponent} from '../apps/ul.component';
import {DotCutDirective} from '@ng-dot/ui/cut';

export const IMR_APP_SHARED_VIEWS = [
	MainHeadComponent,
	UlComponent,
	DlsComponent,
	TechnologyAdvantagesComponent,
	ScreenshotsComponent,
	ImrPipe
];

export const IMR_APP_SHARED_MODULES = [
	CommonModule,
	SinceYearModule,
	TranslateModule
];

@NgModule({
	declarations: IMR_APP_SHARED_VIEWS,
  imports: [
    IMR_APP_SHARED_MODULES,
    DotCutDirective
  ],
	exports: [
		...IMR_APP_SHARED_MODULES,
		...IMR_APP_SHARED_VIEWS
	]
})
export class AppSharedModule {
	static translateLoader(prefix: string) {
		if (!prefix.startsWith('/')) {
			prefix = '/' + prefix;
		}
		if (!prefix.endsWith('/')) {
			prefix += '/';
		}
		return function (http: HttpClient) {
			return new TranslateHttpLoader(http, './assets/i18n' + prefix, '.json');
		};
	}
}
